import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./AmbientalL1.module.css";
import { AmbientalStore } from "./AmbientalStore";

function AmbientalL1({ distrito }) {
  const [nascentes, setNascentes] = useState(null);
  const [aguaCorrente, setAguaCorrente] = useState(null);
  const [mata, setMata] = useState(null);
  const [nascentesOldValue, setNascentesOldValue] = useState(null);
  const [aguaCorrenteOldValue, setAguaCorrenteOldValue] = useState(null);
  const [mataOldValue, setMataOldValue] = useState(null);

  const nascentesValue = AmbientalStore((state) => state.nascentesValue);

  const aguaCorrenteValue = AmbientalStore((state) => state.aguaCorrenteValue);

  const mataValue = AmbientalStore((state) => state.mataValue);

  const agrotoxicoValue = AmbientalStore((state) => state.agrotoxicoValue);

  const problemaSaudeAgrotoxicoValue = AmbientalStore(
    (state) => state.problemaSaudeAgrotoxicoValue
  );

  const setNascentesValue = AmbientalStore((state) => state.setNascentesValue);

  const setAguaCorrenteValue = AmbientalStore(
    (state) => state.setAguaCorrenteValue
  );

  const setMataValue = AmbientalStore((state) => state.setMataValue);

  const setNascentesImage = AmbientalStore((state) => state.setNascentesImage);

  const setAguaCorrenteImage = AmbientalStore(
    (state) => state.setAguaCorrenteImage
  );

  const setMataImage = AmbientalStore((state) => state.setMataImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [nascentes, aguaCorrente, mata] = await Promise.all([
          Api.getNascentes(
            distrito,
            null,
            aguaCorrenteValue,
            mataValue,
            agrotoxicoValue,
            problemaSaudeAgrotoxicoValue
          ),
          Api.getAguaCorrente(
            distrito,
            nascentesValue,
            null,
            mataValue,
            agrotoxicoValue,
            problemaSaudeAgrotoxicoValue
          ),
          Api.getMata(
            distrito,
            nascentesValue,
            aguaCorrenteValue,
            null,
            agrotoxicoValue,
            problemaSaudeAgrotoxicoValue
          ),
        ]);
        setNascentes(Functions.buildSmallPieGraphParams(nascentes));
        setAguaCorrente(Functions.buildSmallPieGraphParams(aguaCorrente));
        setMata(Functions.buildSmallPieGraphParams(mata));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, nascentesValue, aguaCorrenteValue, mataValue, agrotoxicoValue, problemaSaudeAgrotoxicoValue]);

  const onNascentesClick = (value) => {
    setNascentesValue(value);
  };

  const onAguaCorrenteClick = (value) => {
    setAguaCorrenteValue(value);
  };

  const onMataClick = (value) => {
    setMataValue(value);
  };

  return (
    <div className={styles.ambientalL1}>
      <div className={styles.smallPiegraph}>
        {nascentes && (
          <SmallPieGraph
            data={nascentes}
            text="NASCENTES"
            onLegendClick={onNascentesClick}
            currentValue={nascentesValue}
            oldValue={nascentesOldValue}
            onOldValue={setNascentesOldValue}
            onImageReady={setNascentesImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {aguaCorrente && (
          <SmallPieGraph
            data={aguaCorrente}
            text="ÁGUA CORRENTE"
            onLegendClick={onAguaCorrenteClick}
            currentValue={aguaCorrenteValue}
            oldValue={aguaCorrenteOldValue}
            onOldValue={setAguaCorrenteOldValue}
            onImageReady={setAguaCorrenteImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {mata && (
          <SmallPieGraph
            data={mata}
            text="MATA"
            onLegendClick={onMataClick}
            currentValue={mataValue}
            oldValue={mataOldValue}
            onOldValue={setMataOldValue}
            onImageReady={setMataImage}
          />
        )}
      </div>
    </div>
  );
}

export default AmbientalL1;
